/* Footer newsletter success toast (BACKLOG P2-4 fix).
   Shopify's customer form does a full-page POST and redirects back with
   ?customer_posted=true — that param is the only trustworthy success signal,
   so the toast renders on load instead of on submit (the old submit-timeout
   version showed success even for failed posts, and its action*="contact"
   selector also caught the contact page's form).
   Scoped to the footer form only; the email popup owns its posts via the
   contact[id] round trip and renders its own success panel instead. */
document.addEventListener('DOMContentLoaded', () => {
  const params = new URLSearchParams(window.location.search);
  if (params.get('customer_posted') !== 'true') return;

  // The popup's success/error panel present means the popup owned this post.
  if (document.querySelector('[data-sentio-email-popup] [data-popup-state]')) return;

  const form = document.querySelector('form.sentio-footer__signup-form');
  if (!form) return;

  let successEl = form.querySelector('.sentio-newsletter-success');
  if (!successEl) {
    successEl = document.createElement('div');
    successEl.className = 'sentio-newsletter-success';
    successEl.innerHTML = `
      <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round">
        <path d="M20 6L9 17l-5-5"/>
      </svg>
      <span>You're subscribed! Welcome to Sentio.</span>
    `;
    form.appendChild(successEl);
  }
  successEl.classList.add('show');

  form.querySelectorAll('input, button').forEach((el) => {
    if (!el.classList.contains('sentio-newsletter-success')) {
      el.style.display = 'none';
    }
  });

  // The redirect lands at the top of the page; the form lives in the footer.
  const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  form.scrollIntoView({ block: 'center', behavior: reduceMotion ? 'auto' : 'smooth' });
});
